/* drain: ficha de producto (opciones, carrito, barra fija) y reproductor A/B */
if (!customElements.get('drain-product')) {
  customElements.define('drain-product', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-product-form]');
      this.idInput = this.querySelector('[data-variant-id]');
      this.addBtn = this.querySelector('[data-add]');
      this.err = this.querySelector('[data-error]');
      const json = this.querySelector('[data-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];

      this.querySelectorAll('[data-option-position]').forEach((r) => r.addEventListener('change', () => this.onOption()));
      this.form?.addEventListener('submit', (e) => this.submit(e));

      // Galería
      const main = this.querySelector('.d-pdp__img');
      this.querySelectorAll('[data-thumb]').forEach((t) => t.addEventListener('click', () => {
        if (!main) return;
        main.removeAttribute('srcset'); main.src = t.dataset.thumb;
        this.querySelectorAll('[data-thumb]').forEach((x) => x.classList.toggle('is-active', x === t));
      }));

      // Barra fija en móvil: aparece cuando el botón principal sale de pantalla
      this.bar = this.querySelector('[data-sticky-bar]');
      if (this.bar && this.addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => {
          const show = !en.isIntersecting && en.boundingClientRect.top < 0;
          this.bar.classList.toggle('is-visible', show);
          this.bar.setAttribute('aria-hidden', String(!show));
          this.bar.querySelector('[data-sticky-add]').tabIndex = show ? 0 : -1;
        }).observe(this.addBtn);
        this.bar.querySelector('[data-sticky-add]').addEventListener('click', () => {
          if (this.form.querySelector('[required]')) { this.addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          if (this.addBtn.disabled) return;
          this.form.requestSubmit();
        });
      }
      this.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => {
        const i = this.querySelector('[data-qty-input]');
        i.value = Math.min(20, Math.max(1, (parseInt(i.value, 10) || 1) + Number(b.dataset.qty)));
        this.updateVolume();
      }));
      this.querySelector('[data-qty-input]')?.addEventListener('input', () => this.updateVolume());
      this.updateVolume();
      this.onOption(true);
    }

    selected() {
      const sel = [];
      this.querySelectorAll('[data-option-position]:checked').forEach((r) => { sel[Number(r.dataset.optionPosition) - 1] = r.value; });
      return sel;
    }

    onOption(initial) {
      if (!this.variants.length) return;
      const sel = this.selected();
      const v = this.variants.find((x) => x.options.every((o, i) => o === sel[i]));
      // Marcar combinaciones no disponibles
      this.querySelectorAll('[data-option-position]').forEach((r) => {
        const pos = Number(r.dataset.optionPosition) - 1;
        const test = [...sel]; test[pos] = r.value;
        const ok = this.variants.some((x) => x.available && x.options.every((o, i) => o === test[i]));
        r.classList.toggle('is-unavailable', !ok);
      });
      if (!v) { this.setBtn(false, 'No disponible'); return; }
      this.idInput.value = v.id;
      this.setBtn(v.available, v.available ? 'Añadir al carrito' : 'Agotado');
      const vol = this.querySelector('[data-vol]');
      if (vol) { vol.dataset.volBase = v.price; vol.dataset.volUnit = v.price - Number(vol.dataset.volOff); this.updateVolume(); }
      const tpl = this.querySelector(`[data-price-for="${v.id}"]`);
      if (tpl) this.querySelector('[data-price]').innerHTML = tpl.innerHTML;
      const sp = this.querySelector('[data-sticky-price]');
      if (sp && tpl) sp.textContent = tpl.content.querySelector('.d-price__now')?.textContent.trim() || sp.textContent;
      if (!initial) {
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    // Tramos por cantidad: marca el tramo activo y enseña el total (el descuento real lo aplica Shopify en el carrito)
    updateVolume() {
      const box = this.querySelector('[data-vol]');
      const input = this.querySelector('[data-qty-input]');
      if (!box || !input) return;
      const q = Math.max(1, parseInt(input.value, 10) || 1);
      const min = Number(box.dataset.volMin);
      const base = Number(box.dataset.volBase);
      const unit = Number(box.dataset.volUnit);
      const deal = q >= min;
      const eur = (c) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: c % 100 ? 2 : 0 }).format(c / 100);
      box.querySelector('[data-vol-base-price]').textContent = eur(base);
      box.querySelector('[data-vol-unit-price]').textContent = eur(unit);
      box.querySelector('[data-vol-save]').textContent = eur(base - unit);
      box.querySelector('[data-vol-tier="base"]').classList.toggle('is-active', !deal);
      box.querySelector('[data-vol-tier="deal"]').classList.toggle('is-active', deal);
      const total = box.querySelector('[data-vol-total]');
      if (deal) {
        total.innerHTML = `Total: ${q} × ${eur(unit)} = <strong>${eur(q * unit)}</strong> <span>(ahorras ${eur(q * (base - unit))})</span>`;
      } else {
        const left = min - q;
        const lbl = document.createElement('span'); lbl.textContent = box.dataset.volLabel || '';
        total.innerHTML = `Total: <strong>${eur(q * base)}</strong> <span>Añade ${left} más y pagas ${eur(unit)} por ${lbl.innerHTML}.</span>`;
      }
    }

    setBtn(enabled, text) { if (!this.addBtn) return; this.addBtn.disabled = !enabled; this.addBtn.dataset.soldout = String(!enabled); this.addBtn.textContent = text; }

    async submit(e) {
      e.preventDefault();
      this.err.hidden = true;
      // WhatsApp: prefijo + número en un solo valor. Si escriben el número con "+" o "00", se respeta.
      let badTel = null;
      this.form.querySelectorAll('[data-tel]').forEach((t) => {
        const num = t.querySelector('[data-tel-number]');
        let raw = num.value.trim().replace(/[\s().-]/g, '');
        let full = '';
        let pretty = '';
        if (raw.startsWith('00')) raw = '+' + raw.slice(2);
        if (raw.startsWith('+')) { full = raw; pretty = raw; }
        else if (raw) {
          const pre = t.querySelector('[data-tel-prefix]').value;
          const rest = raw.replace(/^0+/, '');
          full = pre + rest; pretty = pre + ' ' + rest;
        }
        const digits = full.replace(/\D/g, '');
        const ok = !raw ? !t.hasAttribute('data-required') : /^\+\d+$/.test(full) && digits.length >= 8 && digits.length <= 15;
        num.classList.toggle('is-invalid', !ok);
        if (!ok && !badTel) badTel = num;
        t.querySelector('[data-tel-value]').value = pretty;
      });
      if (badTel) { this.showError('Revisa tu WhatsApp: elige el prefijo de tu país y escribe el número completo.'); badTel.focus(); return; }
      // Casillas: juntar las marcadas en un solo valor
      this.form.querySelectorAll('[data-group]').forEach((g) => {
        const vals = [...g.querySelectorAll('[data-group-option]:checked')].map((c) => c.value);
        g.querySelector('[data-group-value]').value = vals.join(', ');
      });
      // Validación de los campos del encargo
      let bad = null;
      this.form.querySelectorAll('[data-group][data-required]').forEach((g) => {
        const ok = g.querySelector('[data-group-value]').value !== '';
        g.classList.toggle('is-invalid', !ok);
        if (!ok && !bad) bad = g.querySelector('[data-group-option]');
      });
      this.form.querySelectorAll('input[required], textarea[required], select[required]').forEach((f) => {
        const ok = f.value.trim() !== '' && f.checkValidity();
        f.classList.toggle('is-invalid', !ok);
        if (!ok && !bad) bad = f;
      });
      if (bad) { this.showError('Rellena los campos marcados con * antes de añadir al carrito.'); bad.focus(); return; }

      const drawer = document.querySelector('cart-drawer');
      const fd = new FormData(this.form);
      [...fd.keys()].forEach((k) => { if (k.startsWith('properties[') && fd.get(k) === '') fd.delete(k); });
      if (drawer) {
        fd.append('sections', drawer.getSectionsToRender().map((s) => s.id));
        fd.append('sections_url', window.location.pathname);
      }
      this.addBtn.setAttribute('aria-busy', 'true'); this.addBtn.disabled = true;
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd }).then((r) => r.json());
        if (res.status) throw new Error(res.description || res.message || 'Error');
        if (drawer) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
        else window.location.href = window.routes?.cart_url || '/cart';
      } catch (err) {
        this.showError(err.message || 'No se pudo añadir. Inténtalo de nuevo.');
      } finally {
        this.addBtn.removeAttribute('aria-busy'); this.addBtn.disabled = this.addBtn.dataset.soldout === 'true';
      }
    }

    showError(msg) { this.err.textContent = msg; this.err.hidden = false; }
  });
}

/* Reproductor Antes / Después: cambia de pista sin perder el segundo */
if (!customElements.get('d-ab')) {
  customElements.define('d-ab', class extends HTMLElement {
    connectedCallback() {
      this.a = this.querySelector('[data-ab="a"]');
      this.b = this.querySelector('[data-ab="b"]');
      this.cur = this.b; this.other = this.a;
      this.playBtn = this.querySelector('[data-ab-play]');
      this.fill = this.querySelector('[data-ab-fill]');
      this.bar = this.querySelector('[data-ab-bar]');
      const fmt = (s) => { s = Math.max(0, Math.floor(s || 0)); return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`; };

      this.playBtn.addEventListener('click', () => (this.cur.paused ? this.cur.play() : this.cur.pause()));
      this.querySelectorAll('[data-ab-side]').forEach((btn) => btn.addEventListener('click', () => this.switchTo(btn.dataset.abSide)));
      [this.a, this.b].forEach((au) => {
        au.addEventListener('play', () => { if (au === this.cur) this.playBtn.classList.add('is-playing'); });
        au.addEventListener('pause', () => { if (au === this.cur) this.playBtn.classList.remove('is-playing'); });
        au.addEventListener('ended', () => { this.playBtn.classList.remove('is-playing'); });
        au.addEventListener('loadedmetadata', () => { this.querySelector('[data-ab-dur]').textContent = fmt(this.b.duration || this.a.duration); });
        au.addEventListener('timeupdate', () => {
          if (au !== this.cur) return;
          const p = au.duration ? (au.currentTime / au.duration) * 100 : 0;
          this.fill.style.width = `${p}%`; this.bar.setAttribute('aria-valuenow', String(Math.round(p)));
          this.querySelector('[data-ab-cur]').textContent = fmt(au.currentTime);
        });
      });
      const seek = (clientX) => { const r = this.bar.getBoundingClientRect(); const p = Math.min(1, Math.max(0, (clientX - r.left) / r.width)); if (this.cur.duration) this.cur.currentTime = p * this.cur.duration; };
      this.bar.addEventListener('click', (e) => seek(e.clientX));
      this.bar.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.cur.currentTime += 5;
        if (e.key === 'ArrowLeft') this.cur.currentTime -= 5;
      });
      // La tecla espacio no debe mover la página cuando el foco está en el reproductor
      this.addEventListener('keydown', (e) => { if (e.key === ' ' && e.target === this.bar) { e.preventDefault(); this.playBtn.click(); } });
    }
    switchTo(side) {
      const next = side === 'a' ? this.a : this.b;
      this.querySelectorAll('[data-ab-side]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.abSide === side)));
      if (next === this.cur) return;
      const playing = !this.cur.paused;
      next.currentTime = this.cur.currentTime;
      this.cur.pause(); this.other = this.cur; this.cur = next;
      if (playing) this.cur.play();
    }
  });
}
